import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "pl-4 lg:pl-20 py-14 font-poppins" }
const _hoisted_3 = { class: "m-0 pl-4" }
const _hoisted_4 = { class: "m-0 pl-4" }

import Container from '../components/content/Container.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import Accordion from '@/components/library/Accordion.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Dfsv',
  setup(__props) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const legalDocuments = brandService.getLegalDocuments();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "w-full bg-legal" }, [
      _createElementVNode("div", { class: "py-20 px-4 lg:px-24" }, [
        _createElementVNode("h1", { class: "font-benzin text-white text-4xl uppercase tracking-wide font-normal mt-28" }, "Domestic, Family and Sexual Violence Support"),
        _createElementVNode("div", { class: "w-full md:max-w-48 flex rounded-full bg-gradient-to-tr from-brand-primary-dark to-brand-primary-light p-0.5 shadow-md border-none hover:border-solid hover:border-2 hover:border-white hover:text-white" }, [
          _createElementVNode("button", {
            class: "flex-1 text-lg md:text-18 bg-transparent px-6 py-3 rounded-full font-poppins border-none hover:cursor-pointer",
            onclick: "javascript:window.location.replace('https://recipetineats.com')"
          }, [
            _createElementVNode("a", {
              class: "no-underline text-black",
              href: "https://recipetineats.com/"
            }, "Quick Exit")
          ])
        ])
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "pb-2" }, [
            _createElementVNode("a", {
              href: "/",
              class: "text-primary"
            }, "< Back to home ")
          ], -1)),
          _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "font-poppins-bold" }, "Support Contact Details", -1)),
          _createElementVNode("div", null, [
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "font-bold my-0" }, " If you are in immediate danger, call emergency services on 000. ", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mt-0 mb-5" }, " If you are experiencing domestic, family or sexual violence, Nexee is here to support you. ", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "font-bold pb-0 my-0" }, " How to contact us ", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mt-0 mb-1" }, " You can contact us for confidential assistance during business hours: ", -1)),
            _createElementVNode("p", _hoisted_3, [
              _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Phone:", -1)),
              _createTextVNode(" " + _toDisplayString(_unref(brandService).getSupportPhoneNumber()), 1)
            ]),
            _createElementVNode("p", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Email:", -1)),
              _createTextVNode(" " + _toDisplayString(_unref(brandService).getSupportEmail()), 1)
            ]),
            _cache[6] || (_cache[6] = _createStaticVNode("<p class=\"mb-0\" data-v-2b1b3b3e> Accessibility support is available: <ul class=\"list-disc my-0\" data-v-2b1b3b3e><li class=\"my-0\" data-v-2b1b3b3e>National Relay Service: via the Access Hub</li><li data-v-2b1b3b3e>Interpreting services: Translating and Interpreting Service (TIS National) on 131 450</li></ul></p><p class=\"mb-5\" data-v-2b1b3b3e> You can request a call-back and let us know your preferred and safest way to communicate. </p><p class=\"font-bold my-0 py-0\" data-v-2b1b3b3e> External support services </p><p class=\"my-0 py-0\" data-v-2b1b3b3e> You can also access free, confidential support from specialist services, including: <ul class=\"list-disc my-0 py-0\" data-v-2b1b3b3e><li data-v-2b1b3b3e><strong data-v-2b1b3b3e>1800RESPECT</strong> – 1800 737 732 (24/7 counselling and support)</li><li data-v-2b1b3b3e><strong data-v-2b1b3b3e>Full Stop Australia </strong>– 1800 385 578 (24/7 sexual, domestic and family violence support)</li><li data-v-2b1b3b3e><strong data-v-2b1b3b3e>Lifeline </strong>– 13 11 14 (24/7 crisis support)</li><li data-v-2b1b3b3e><strong data-v-2b1b3b3e>13YARN</strong> – 13 92 76 (24/7 First Nations support)</li></ul></p>", 4))
          ]),
          _createVNode(Accordion, { title: 'Our Domestic, Family and Sexual Violence Statement' }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("p", { class: "font-bold pt-4" }, " Our commitment to your safety ", -1),
              _createElementVNode("p", { class: "mb-5" }, " Uniti Retail Pty Ltd (ACN 154 074 218), trading as Nexee Internet, has policies and procedures in place to protect the safety, privacy and wellbeing of customers affected by domestic and family violence or non-domestic sexual violence. ", -1),
              _createElementVNode("p", { class: "mb-5" }, " We recognise that access to safe and reliable telecommunications is essential for safety, connection and recovery. We are committed to supporting affected persons in a respectful, trauma-informed way and to keeping customers connected to their services wherever possible. ", -1),
              _createElementVNode("p", { class: "font-bold" }, " Keeping you connected ", -1),
              _createElementVNode("p", { class: "mb-5" }, " If your telecommunications service has been restricted, suspended or disconnected and you tell us, this raises concerns about your safety. We will act as a matter of urgency to reverse that action. If reversal is not practical, we will offer an equivalent telecommunications service where available. ", -1),
              _createElementVNode("p", { class: "font-bold" }, " Financial hardship support ", -1),
              _createElementVNode("p", { class: "mb-5" }, " We recognise that domestic, family or sexual violence can be a reason for non-payment. Customers affected by DFSV may be entitled to financial hardship assistance under the Telecommunications (Financial Hardship) Standard 2024. We will work with you to discuss available support options. ", -1),
              _createElementVNode("p", { class: "font-bold" }, " How we can support you ", -1),
              _createElementVNode("p", { class: "mb-5" }, [
                _createTextVNode(" With your consent, we can provide additional support which may include: "),
                _createElementVNode("ul", { class: "list-disc" }, [
                  _createElementVNode("li", null, "agreeing on a safe way and time to contact you"),
                  _createElementVNode("li", null, "applying a confidential DFSV safety flag to your account"),
                  _createElementVNode("li", null, "taking extra steps to protect access to your personal information"),
                  _createElementVNode("li", null, "reviewing fees, charges or credit actions that may affect your safety")
                ]),
                _createTextVNode(" You do not need to share details of the violence to receive support. ")
              ], -1),
              _createElementVNode("p", { class: "mb-5" }, " You can contact us or external support services via the details above. ", -1),
              _createElementVNode("p", { class: "font-bold" }, " Further information ", -1),
              _createElementVNode("p", { class: "mb-5" }, [
                _createTextVNode(" Our "),
                _createElementVNode("a", {
                  href: `/family-violence`,
                  class: "text-primary",
                  target: "_blank"
                }, "DFSV Customer Policy"),
                _createTextVNode(" provides more detail about how we support customers experiencing domestic, family or sexual violence and is available on our website. ")
              ], -1)
            ])),
            _: 1,
            __: [7]
          }),
          _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-primary text-left pt-5 font-poppins-bold" }, [
            _createElementVNode("a", {
              href: `/family-violence`,
              class: "text-primary",
              target: "_blank"
            }, "Nexee’s Domestic, Family and Sexual Violence Policy")
          ], -1))
        ])
      ])
    ])
  ], 64))
}
}

})